import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=c0aad1b2"
import script from "./versions.vue?vue&type=script&lang=js"
export * from "./versions.vue?vue&type=script&lang=js"
import style0 from "../../../assets/sass/commponents/nlp.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports